import OrderApi from "../../../../services/api/orderApi";
import { gmapApi } from "vue2-google-maps";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { mapMutations } from "vuex";

const OrderApiService = new OrderApi();

export default {
  components: {
    VueGoogleAutocomplete,
  },
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      different_billing: false,
      shipping_addresses: [],
      billing_addresses: [],
      selected_shipping_address: null,
      selected_billing_address: null,
      new_shipping_address: null,
      new_billing_address: null,
      model: {
        shipping_address: {
          first_name: "",
          last_name: "",
          company: "",
          street: "",
          apartment: "",
          city: "",
          zip_code: "",
          phone: "",
          country: "",
          state: "",
          default_shipping: false,
          billing: false,
          default_billing: false,
          save_as_retailer_address: false,
        },
        billing_address: {
          first_name: "",
          last_name: "",
          company: "",
          street: "",
          apartment: "",
          city: "",
          zip_code: "",
          phone: "",
          country: "",
          state: "",
          default_billing: false,
          shipping: false,
          default_shipping: false,
          save_as_retailer_address: false,
        },
      },
    };
  },

  methods: {
    getAddresses,
    handleDefaultNewShippingAddress,
    handleDefaultNewBillingAddress,
    validate,
    proceedToOrderReview,
    toggleDifferentBilling,
    selectShippingAddressDropdownCallback,
    selectBillingAddressDropdownCallback,
    onBillingAddressChanged,
    onShippingAddressChanged,
    ...mapMutations(["clearPromoCodeState"]),
  },

  mounted() {
    const _self = this;
    /*
     *check if user was previously on shipping section and has valid address entered
     */
    if (_self.$store.getters.checkoutState.shipping) {
      // eslint-disable-next-line no-underscore-dangle
      _self._data = _self.$store.getters.checkoutState.shipping;
      _self.$nextTick(() => {
        if (_self.new_shipping_address) {
          _self.$refs.shippingAddressAutocomplete.update(_self.model.shipping_address.street);
        }

        if (_self.new_billing_address) {
          _self.$refs.billingAddressAutocomplete.update(_self.model.billing_address.street);
        }
      });

      _self.$forceUpdate();
    } else {
      _self.getAddresses("shipping");
    }

    this.clearPromoCodeState();
  },

  computed: {
    google: gmapApi,
  },
};

function selectShippingAddressDropdownCallback(address) {
  if (address.id) {
    this.new_shipping_address = false;
    this.selected_shipping_address = address;
  } else {
    this.new_shipping_address = true;
    this.selected_shipping_address = {
      name: "New Address",
      id: null,
    };

    this.model.shipping_address = {
      first_name: "",
      last_name: "",
      company: "",
      street: "",
      apartment: "",
      city: "",
      zip_code: "",
      phone: "",
      country: "",
      state: "",
      default_shipping: false,
      billing: false,
      default_billing: false,
      save_as_retailer_address: false,
    };
  }
}

function selectBillingAddressDropdownCallback(address) {
  if (address.id) {
    this.new_billing_address = false;
    this.selected_billing_address = address;
  } else {
    this.new_billing_address = true;
    this.selected_billing_address = {
      name: "New Address",
      id: null,
    };

    this.model.billing_address = {
      first_name: "",
      last_name: "",
      company: "",
      street: "",
      apartment: "",
      city: "",
      zip_code: "",
      phone: "",
      country: "",
      state: "",
      default_billing: false,
      shipping: false,
      default_shipping: false,
      save_as_retailer_address: false,
    };
  }
}

function proceedToOrderReview() {
  this.$router.push("/checkout/order-review");
}

function handleDefaultNewShippingAddress() {
  if (this.model.shipping_address.default_shipping) {
    this.model.shipping_address.save_as_retailer_address = true;
  }
}

function toggleDifferentBilling() {
  if (this.different_billing) {
    this.getAddresses("billing");
  } else {
    this.new_billing_address = false;
    this.selected_billing_address = null;
  }
}

function handleDefaultNewBillingAddress() {
  if (this.model.billing_address.default_billing) {
    this.model.billing_address.save_as_retailer_address = true;
  }
}

function validate() {
  const _self = this;

  this.$validator.validateAll().then(async (valid) => {
    if (!valid) {
      _self.$store.commit("removeCheckoutShipping");

      return;
    }

    _self.$store.commit("setCheckoutAddressInfo", _self._data);
    _self.$router.push("/checkout/order-review");
    _self.$eventBus.$emit("shipping-updated");
  });
}

// type: shipping | billing
async function getAddresses(type) {
  try {
    const { data: addresses } = await OrderApiService.getAddress(type);

    this[`${type}_addresses`] = addresses.map((address) => {
      const addressForDropdown = this.$utils.mapAddressToDropdownItem(address);
      if (!this[`selected_${type}_address`] && address[`default_${type}`]) {
        this[`selected_${type}_address`] = addressForDropdown;
      }
      return addressForDropdown;
    });

    this[`${type}_addresses`].push({
      id: null,
      name: "New Address",
    });
  } catch (error) {
    if (error.response) {
      this.$swal("Attention", error.response.data.error_message);
    } else {
      this.$bugsnagClient.notify(new Error(error));
    }
  }
}

function onBillingAddressChanged(addressObject) {
  this.model.billing_address = { ...this.model.billing_address, ...addressObject };
  this.$store.commit("removeCheckoutShipping");
}

function onShippingAddressChanged(addressObject) {
  this.model.shipping_address = { ...this.model.shipping_address, ...addressObject };
  this.$store.commit("removeCheckoutShipping");
}
